<template>
    <div v-if="!loading" id="content">
        <router-view />
        <PageFooter :marketing="true" />
    </div>
</template>

<script>
import PageFooter from '@/components/Footer.vue'
import Cookies from 'js-cookie'
import {
    TLD,
    COOKIE_TOKEN
} from '@/common/constants'

export default {
    components: {
        PageFooter
    },
    data: function () {
        return {
            loading: true
        }
    },
    created: async function () {
        if (TLD.endsWith('ondigitalocean.app')) {
            document.body.innerHTML = 'oops!'
            return
        }

        await this.$router.isReady()
        const _token = Cookies.get(COOKIE_TOKEN)
        if (_token) {
            await this.$store.commit('INIT_TOKEN', _token)
        }

        await this.$store.dispatch('GET_INFO')
        await this.loaded()
    },
    methods: {
        loaded: async function () {
            this.loading = false
            setTimeout(function () {
                document.body.classList.remove('loading')
                document.getElementById('app-loader')?.remove()
            }, 500)
        }
    }
}
</script>

<style lang="scss">
    @import '@/assets/scss/style.scss';
</style>
